import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';

import {when} from 'lit/directives/when.js';
import {conditional} from '../../../util/conditional';
import store from '../../../store';
import {classes} from '../../../../../common/tpl/directives';
import {filterAndJoin} from '../../../util/filterAndJoin';
import {selectSolarActivityLevel, selectSolarShadowLevel} from '../../solarSelectors';
import {solarActivityLevelOptions, solarShadowLevelOptions} from '../../solarSectionConfig';
import {pimText, pimTextDebug} from '../../../util/values';
import {cssProperties} from '../../../css/cssProperties';

@customElement('page-solar-summary')
export class PageSolarSummary extends connect(store)(LitElement) {

	static styles = [
		css`
	:host {
		margin: 0 var(--specsheet-large-gap) var(--specsheet-medium-gap) var(--specsheet-large-gap);
	}

	.imageContainer img {
		text-align: center;
		max-height: 45vh;
		width: 100%;
		margin-left: auto;
		margin-right: auto;
		object-fit: cover;
	}

	.tableDataContainer {
		display: table;
		width: 100%;

		.description {
			display: table-cell;
			width: 50%;
		}

		.featuresTable {
			display: table-cell;
			width: 50%;

			.featureTableCell .row {
				border-bottom: 1px solid black;
			}

			.featureTableCell.single .row {
				border-bottom: 1px solid black;
			}
		}
	}

	.descriptionSection {
		padding-bottom: var(--specsheet-medium-gap);
	}

	@media print {
		:host {
			padding-top: 5vw;
			width: 100vw;
			margin: 0;
		}

		.imageContainer {
			text-align: center;
			width: 100%;
			max-height: 570px;
			height: auto;
		}

		.descriptionSection {
			padding-bottom: var(--specsheet-small-gap);
		}
	}

	`]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.featuremodel = state.featureModel;
		this.productData = state.productData;
		this.status = state.status;
		this.lang = state.status.lang;
		this.decisions = state.decisions.data;

		this.solar = state.solar.data;
		this.location = this.solar.project.location;
	}
	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.decisions, this.state.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.decisions, this.state.productData.translations, value, prefix, suffix);
	}

	render() {
		const s = this.state;

		return html`
        <div class="summary">
			<section class="descriptionSection">
				<div class="description">
					<p>${msg('Designed slim solar system luminaire that can be flexibly adapted to the environment and project requirements.')}</p>
				</div>
			</section>
			<section class="imageSection">
				<div class="imageContainer">
					<img class="img" src="/line-assets/img/aeto-familie-summary.png"/>
				</div>
			</section>
			<section class="tableData">
				<div class="tableDataContainer">
					<div class="coverTable">
					<cover-table title="Familiendaten">
						<cover-table-item style-choice="no-border">
   							<div slot="label">${msg('Product Model')}</div>
   							<div slot="value">
								${filterAndJoin([
								this.t('HS_HousingSize', 'FV.S'),
								this.t('HS_HousingType', 'FV.S'),
							], ' ')}
							</div>
						</cover-table-item>
					</cover-table>

					<cover-table title="Anwendung">
						<cover-table-item>
							<div slot="label">${msg('Location')}</div>
							<div slot="value">
								${this.location?.name} (${msg('Latitude')}: ${this.location?.latitude}, ${msg('Longitude')}: ${this.location?.longitude})
							</div>
						</cover-table-item>
						<cover-table-item>
							<div slot="label">${msg('Pedestrian Activity')}</div>
							<div slot="value">${solarActivityLevelOptions.find(o  => o.id === selectSolarActivityLevel(s)).label[this.lang]}</div>
						</cover-table-item>
						<cover-table-item style-choice="no-border">
							<div slot="label">${msg('Shading Level')}</div>
							<div slot="value">${solarShadowLevelOptions.find(o  => o.id === selectSolarShadowLevel(s)).label[this.lang]}</div>
						</cover-table-item>
					</cover-table>

					</div>
				</div>

			</section>
		</div>
		`;
	}
}
